import Masonry from 'react-masonry-css';
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding-left: ${({ theme }) => theme.spacing(2)};
  padding-right: ${({ theme }) => theme.spacing(2)};
  padding-bottom: ${({ theme }) => theme.spacing(6)};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-bottom: ${({ theme }) => theme.spacing(8)};
  }
`;

export const TitleWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.secondaryLightGrey};
  padding-top: ${({ theme }) => theme.spacing(7)};
  padding-bottom: ${({ theme }) => theme.spacing(7)};
`;

export const Container = styled.div`
  max-width: ${({ theme }) => theme.breakpoints.lg};
  margin: 0 auto;
`;

export const TextContainer = styled.div`
  max-width: ${({ theme }) => theme.breakpoints.lg};
  margin: 0 auto;
  text-transform: uppercase;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  font-family: ${({ theme }) => theme.fontFamilies.italianPlate};
  font-size: ${({ theme }) => theme.fontSizes.h2};
  margin-bottom: ${({ theme }) => theme.spacing(3.5)};
`;

export const Title = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  font-family: ${({ theme }) => theme.fontFamilies.italianPlate};
  font-size: ${({ theme }) => theme.fontSizes.h1};
  text-align: center;
  text-transform: uppercase;
`;

export const StyledMasonry = styled(Masonry)`
  display: flex;
  margin-left: -${({ theme }) => theme.spacing(3)};
  width: auto;

  .masonry-grid_column {
    padding-left: ${({ theme }) => theme.spacing(3)};
    background-clip: padding-box;

    > div {
      margin-bottom: ${({ theme }) => theme.spacing(3)};
    }
  }
`;
